import React, { useContext } from "react";
import AppContext from "../contexts/AppContext";
import { useHistory } from "react-router";
import { setProject, setProjectMemberships } from "../actions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import componentStyles from "../assets/styles/components/project_list";

import { useTranslation } from "react-i18next";
const useStyles = makeStyles(componentStyles);

const ProjectList = () => {
  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const handleClickSetProjectButton = async (project) => {
    await setProject(dispatch, { project: project });
    history.push("/project/" + project.id + "/issues");
  };

  const handleClickResetProjectButton = async () => {
    await setProjectMemberships(dispatch, []);
    await setProject(dispatch, { project: {} });
    history.push("/project/issues");
  };

  return (
    <>
      <List className={classes.listRoot}>
        <ListItem
          button
          onClick={(e) => handleClickResetProjectButton()}
          className={classes.listItemRoot}
        >
          <ListItemIcon>
            {
              <FiberManualRecordIcon
                style={
                  !state.current.project ||
                  !Object.keys(state.current.project).length
                    ? { color: theme.palette.success.snackbar }
                    : { color: theme.palette.gray[300] }
                }
              />
            }
          </ListItemIcon>
          <ListItemText primary={<Typography>{t("label_all")}</Typography>} />
        </ListItem>
        {state.projects.map((project, index) => {
          return (
            <ListItem
              key={index}
              button
              onClick={(e) => handleClickSetProjectButton(project)}
              className={classes.listItemRoot}
            >
              <ListItemIcon>
                {
                  <FiberManualRecordIcon
                    style={
                      state.current.project &&
                      project.id === state.current.project.id
                        ? { color: theme.palette.success.snackbar }
                        : { color: theme.palette.gray[300] }
                    }
                  />
                }
              </ListItemIcon>
              <ListItemText primary={<Typography>{project.name}</Typography>} />
            </ListItem>
            // <Divider component="li" />
          );
        })}
      </List>
    </>
  );
};

export default ProjectList;
